import {
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Slide,
  Dialog,
  Divider,
  TextField,
  Button,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { ReactComponent as DocumentIcon } from "../assets/document.svg";
import { useState, forwardRef, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { ko } from "date-fns/locale";
/** @jsxImportSource @emotion/react */
import { jsx, css, keyframes } from "@emotion/react";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";
import { configState } from "../lib/State";
import Swal from "sweetalert2";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReviewReceiptHelp from "./ReviewReceiptHelp";
import ReviewBlogHelp from "./ReviewBlogHelp";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const fieldTheme = createTheme({
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: "100%",
          marginBottom: "10px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: "40px",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: "-7px",
        },
        shrink: {
          top: "0",
        },
      },
    },
  },
});

const multilineTheme = createTheme({
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: "100%",
          marginBottom: "10px",
          wordBreak: "break-all",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          top: "4px",
        },
        shrink: {
          transform: "translate(14px, -9px)",
          top: 0,
        },
      },
    },
  },
});

const tableTheme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          padding: "10px",
          width: "77%",
        },
        head: {
          fontWeight: "bold",
          width: "23%",
        },
      },
    },
  },
});

function Review(props) {
  const { login } = props;
  const [open, setOpen] = useState(false);
  const [site, setSite] = useState("");
  const cid = get_cid();
  const center = get_center(cid);
  const token = get_token();
  const [seq, setSeq] = useState(0);
  const [type, setType] = useState("");
  const [review_url, setReview_url] = useState(null);
  const [regdate, setRegdate] = useState("");
  const [state, setState] = useState("");
  const [reason, setReason] = useState("");
  const [reSubmit, setReSubmit] = useState(false);
  const [inputUrl, setInputUrl] = useState("");
  let local;
  switch (cid) {
    case "CID00000009":
      local = "정관";
      break;
    case "CID00000017":
      local = "아주";
      break;
    case "CT17X10111035.huwy5":
      local = "고현";
      break;
    default:
      local = "OO";
      break;
  }
  const siteData = {
    nplace: {
      name: "네이버플레이스",
      placeHolder: "네이버 플레이스 포스팅 주소",
      reviewCondition: "결제 영수증 사진 포함",
      reviewHelp: <ReviewReceiptHelp />,
      img: "naverplace.png",
      cash: "한달에 1회 - 5,000 캐시",
    },
    blog: {
      name: "블로그",
      placeHolder: "네이버 블로그 리뷰 포스팅 주소",
      reviewCondition: `1. 두써킷 방문 인증샷 3장 이상 포함 <br />
      2. 지정 해시태그 포함 <br />
      <span class="text-xs text-slate-600">(#두써킷 #두써킷센터 #두써킷${local}점 #${local}헬스장 #${local}PT)</span> <br />
      3. 글자수 1,000자 이상`,
      reviewHelp: <ReviewBlogHelp />,
      img: "blog.png",
      cash: "한달에 1회 - 10,000 캐시",
    },
    kakaomap: {
      name: "카카오맵",
      placeHolder: "카카오맵 리뷰 주소",
      reviewCondition: "자유 양식",
      reviewHelp: null,
      img: "kakaomap2.png",
      cash: "한달에 1회 - 5,000 캐시",
    },
    googlemap: {
      name: "구글맵",
      placeHolder: "구글맵 리뷰 주소",
      reviewCondition: "자유 양식",
      reviewHelp: null,
      img: "googlemap.png",
      cash: "한달에 1회 - 5,000 캐시",
    },
    insta: {
      name: "인스타",
      placeHolder: "인스타 리뷰 주소",
      reviewCondition: `1. 두써킷 방문 인증샷 1장 이상 포함 <br />
      2. 지정해시태그 포함 <br />
      <span class="text-xs text-slate-600">(#두써킷 #${local}그룹PT #두써킷${local}점 #${
        local === "아주" ? "아주동" : local
      }다이어트)</span>`,
      reviewHelp: null,
      img: "instagram.png",
      cash: "하루 1회 - 100 캐시",
    },
  };

  const openClick = () => {
    setOpen(true);
  };

  const closeClick = () => {
    setOpen(false);
  };

  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass/review_state", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    setSeq(result.data.seq);
    setType(result.data.type);
    setReview_url(result.data.review_url);
    setRegdate(result.data.regdate);
    setState(result.data.state);
    setReason(result.data.reason);
  };

  useEffect(() => {
    if (open === true) {
      load_data();
    }
  }, [open]);

  useEffect(() => {
    if (open === true) {
      setSite("");
      setInputUrl("");
      setReSubmit(false);
    }
  }, [open]);

  useEffect(() => {
    setInputUrl("");
  }, [site]);

  const onSubmit = async () => {
    const data = {
      token: token,
      cid: cid,
      level: login.level,
      mcd: login.mcd,
      site: site,
      review_url: inputUrl,
    };
    let result = await axios.post(
      configState.api + "/gympass/review_add",
      data
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({
        text: "리뷰 인증 신청이 완료됐습니다. 진행사항은 리뷰 인증 페이지에서 확인 가능합니다.",
        showCloseButton: true,
      }).then((result) => {
        load_data();
        setReSubmit(false);
      });
    }
  };

  return (
    <Box>
      <Dialog
        fullScreen
        open={open}
        onClose={closeClick}
        TransitionComponent={Transition}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img src="/img/back_button_black.png" onClick={closeClick} />
          <Box
            sx={{
              margin: "16px 0 0 10px",
              fontSize: "22px",
              fontWeight: "bold",
            }}
          >
            리뷰 인증
          </Box>
        </Box>
        <Divider />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "80%",
            }}
          >
            <Box
              sx={{
                fontWeight: "bold",
                marginTop: "30px",
                marginBottom: "10px",
              }}
            >
              리뷰 인증 안내
            </Box>
            <Box
              sx={{
                fontSize: "14px",
              }}
            >
              <Box>
                SNS에서 리뷰를 등록하고 어플에서 리뷰 인증을 하면 캐시를 받을 수
                있는 제도입니다.
              </Box>
              <Box>신청시 담당자 인증 후 캐시가 지급됩니다.</Box>
            </Box>

            {seq > 0 && (
              <>
                <Box
                  sx={{
                    marginTop: "20px",
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    리뷰 신청 현황
                  </Box>
                  <ThemeProvider theme={tableTheme}>
                    <Table>
                      <TableBody
                        sx={{
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                      >
                        <TableRow>
                          <TableCell variant="head">등록일</TableCell>
                          <TableCell>
                            {moment(regdate).format("YYYY-MM-DD")}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell variant="head">사이트</TableCell>
                          <TableCell>{type}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell variant="head">주소</TableCell>
                          <TableCell
                            sx={{
                              maxWidth: 0,
                              width: "20%",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            // onClick={() => window.open(item.review_url)}
                          >
                            {review_url}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell variant="head">상태</TableCell>
                          <TableCell
                            style={
                              state === "승인거절" ? { color: "red" } : null
                            }
                          >
                            {state}
                          </TableCell>
                        </TableRow>
                        {state === "승인거절" && (
                          <TableRow>
                            <TableCell variant="head">거절사유</TableCell>
                            <TableCell>{reason}</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </ThemeProvider>
                </Box>
                {state !== "회원등록" && (
                  <Box
                    sx={{
                      marginTop: "20px",
                    }}
                  >
                    {reSubmit === false && (
                      <Box
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                        onClick={() => setReSubmit(true)}
                      >
                        다시신청하기 <KeyboardArrowRightIcon />
                      </Box>
                    )}
                    {reSubmit === true && (
                      <Box
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                        onClick={() => setReSubmit(false)}
                      >
                        다시신청하기 <KeyboardArrowDownIcon />
                      </Box>
                    )}
                  </Box>
                )}
              </>
            )}

            {/* 리뷰 등록한 사이트 선택 */}

            {(seq === 0 || reSubmit === true) && (
              <>
                <Box
                  sx={{
                    marginTop: "20px",
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    리뷰 등록 사이트 선택
                  </Box>

                  {/* site change button */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    {Object.keys(siteData).map((key, index) => (
                      <Box
                        style={{ borderRadius: "15px" }}
                        onClick={() => setSite(siteData[key].name)}
                        key={index}
                      >
                        <img
                          src={`/img/${siteData[key].img}`}
                          height="60px"
                          width="60px"
                          style={{
                            opacity: site === siteData[key].name ? "1" : "0.5",
                          }}
                        />
                        <Box
                          className="text-center text-xs"
                          dangerouslySetInnerHTML={{
                            __html:
                              siteData[key].name === "네이버플레이스"
                                ? "네이버<br />플레이스"
                                : siteData[key].name === "블로그"
                                ? "네이버<br />블로그"
                                : siteData[key].name,
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* review URL input */}
                {Object.keys(siteData).map(
                  (key, index) =>
                    site === siteData[key].name && (
                      <Box className="mt-5" key={index}>
                        <Box className="font-black mb-1">리뷰 인증 조건</Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginBottom: "10px",
                            wordBreak: "break-all",
                          }}
                        >
                          <Box
                            dangerouslySetInnerHTML={{
                              __html: siteData[key].reviewCondition,
                            }}
                          />
                          {siteData[key].reviewHelp && siteData[key].reviewHelp}
                        </Box>
                        <Box className="font-black mb-1">캐시 지급 조건</Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginBottom: "10px",
                            wordBreak: "break-all",
                          }}
                        >
                          {siteData[key].cash}
                        </Box>
                        <Box
                          sx={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                          }}
                        >
                          리뷰 주소 입력
                        </Box>
                        <ThemeProvider theme={multilineTheme}>
                          <TextField
                            label={`${siteData[key].placeHolder}를 입력해주세요.`}
                            size="small"
                            value={inputUrl}
                            onChange={(e) => setInputUrl(e.target.value)}
                          />
                        </ThemeProvider>
                        <div className="flex gap-2 justify-end">
                          {center?.sns_review?.[key] && (
                            <Button
                              variant="contained"
                              onClick={() =>
                                window.open(center?.sns_review?.[key])
                              }
                              sx={{ background: "#3a9fde" }}
                            >
                              바로가기
                            </Button>
                          )}
                          <Button
                            variant="contained"
                            onClick={onSubmit}
                            sx={{ background: "#0092a2" }}
                          >
                            인증신청
                          </Button>
                        </div>
                      </Box>
                    )
                )}
              </>
            )}
          </Box>
          <Box sx={{ height: "50px", width: "100%" }}></Box>
        </Box>
      </Dialog>

      <ListItem sx={{ textAlign: "center" }} onClick={openClick}>
        <ListItemAvatar>
          <DocumentIcon width="24px" height="24px" />
        </ListItemAvatar>
        <ListItemText sx={{ textAlign: "left" }}>리뷰인증</ListItemText>
        <ListItemAvatar>
          <ArrowRightIcon />
        </ListItemAvatar>
      </ListItem>
    </Box>
  );
}

export default Review;
